import { PerformanceTrackingPort } from '../../shared/ports'

export class LoadTimeMeasurement {
  static readonly metricNameCbLoadingTime = 'rum_consent_banner_loading_time'
  static readonly metricNameCbInit = 'consent_banner_init'
  static readonly metricNameCbLoaded = 'consent_banner_loaded'

  constructor(
    private readonly performanceTrackingService: PerformanceTrackingPort
  ) {}

  startLoadTimeMeasurement() {
    this.performanceTrackingService.markPerformanceMetric(
      LoadTimeMeasurement.metricNameCbInit
    )
  }

  finishLoadTimeMeasurement() {
    this.performanceTrackingService.markPerformanceMetric(
      LoadTimeMeasurement.metricNameCbLoaded
    )
    this.performanceTrackingService.sendMeasurement(
      LoadTimeMeasurement.metricNameCbInit,
      LoadTimeMeasurement.metricNameCbLoaded,
      LoadTimeMeasurement.metricNameCbLoadingTime
    )
  }
}
